export default __webpack_public_path__ + "static/media/telegram.666dbfa6.svg";